import {ref, unref} from 'vue';
import {loadDomainList, loadListByUrl} from "@/api/domainApi/domainComApi";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {deepClone, GoingNewUtils} from "xmgoing-utils";
import {StorageUtils} from 'xmgoing-utils';
import {appendLoadWhenChangeWatchValues, getFilterJson, initQueryParamsObj, isRequiredQueryUserParamMissing} from "@/main-page/utils/domainQueryUtils";
import {Base64} from 'js-base64' ;
import {useDatasSubListHooks} from "@/main-page/ctls/hooks/useDatasSubListHooks";
import GoingUtils from "@/utils/goingUtils";
import {md5Str} from "xmgoing-utils";
import {initSuccessDealDealStr} from '@/store/utils/dataSourceUtils'
import {isOnceFullListPayload} from '@/main-page/ctls/dataDealHooks/onceFullListPayload'

/**
 * 系统参数集合
 */
export const systemParamsMap = {
    sessionId: StorageUtils.getSessionItem("sessionId"),
    projectI18n: StorageUtils.getItem("projectI18n"),
    currentYear: 'systemParams.currentYear',
    currentYearMonth: 'systemParams.currentYearMonth',
    currentDate: 'systemParams.currentDate',
    currentDay: 'systemParams.currentDay',
    currentWeek: 'systemParams.currentWeek',
    currentMonth: 'systemParams.currentMonth',
    currentQuarter: 'systemParams.currentQuarter',
}
/**
 * 有可能路径是全局变量
 * @param pageModelsStore
 * @param queryUrl
 */
const initQueryUrl = function (pageModelsStore, queryUrl) {
    if ((queryUrl + '').indexOf("vuex.") >= 0) {
        const ary = queryUrl.split(".");
        return pageModelsStore.state[ary[ary.length - 1]];
    }
    return queryUrl;
}

/**
 * 获取记录集合sql授权
 * @param ctlAclInfos
 * @param props
 */
export const getSqlContentParams = function (gridKey, ctlAclInfos) {
    //根据权限找出需要隐藏的列信息
    const sqlContentList = [];
    if (gridKey&&unref(ctlAclInfos) && Array.isArray(unref(ctlAclInfos))) {
        unref(ctlAclInfos).forEach((aclRecord) => {
            if (aclRecord['tableList'] && Array.isArray(aclRecord['tableList']) && aclRecord['tableList'].length > 0) {
                const selItem = aclRecord['tableList'].filter((itemDb) => {
                    return itemDb.key === gridKey
                })[0];
                if (selItem && selItem['sqlConfigs']) {
                    sqlContentList.push(selItem['sqlConfigs']);
                }
            }
        })
        const maxContent = sqlContentList.reduce((max, current) => {
            return current.sqlLevel > max.sqlLevel ? current : max;
        }, {sqlLevel: -Infinity, sqlContent: ''}).sqlContent;
        if (maxContent) {
            return {s_: Base64.encode(maxContent), sv_: md5Str(Base64.encode(maxContent))}
        }
        return {};
    }
    return {};
}


/**
 * @param onLoadWhenChange 参数变化时的刷新回调。表格需走 initCtlDataFun 才会触发 afterLoadData；
 *   未传入时保持原逻辑，只回写 tableDs（查询会发出，加载完成动作不会执行）。
 */
export default function ({
                             columns,
                             editorRecord,
                             dataConfig,
                             gridKey,
                             ctlAclInfos,
                             pageSize = 10000,
                             queryData = true,
                             tableObj = {},
                             onLoadWhenChange,
                         }: any) {

    const {
        setSubGridQueryScope,
        initSubGridRecords,
        subGridListScopeFlag,
        subGridListScopeVal
    } = useDatasSubListHooks();

    const pageSizeRef = ref(pageSize);
    const afterLoadingFlag = ref(false);
    const tableDs: any = ref([]);
    const loadingFlag: any = ref(true);
    const pageTotal: any = ref(0);
    const tableLoading: any = ref(false);
    const watchVuexFlag = ref(false);


    //默认查询第一页
    const current = ref(1);
    const dataSourceStore = useDataSourceStore();
    const pageModelsStore = usePageModelsStore();

    const closeCurLoading=function (){
        GoingUtils.closeLoading();
        loadingFlag.value=false;
    }

    /**
     * 同步判断必填查询参数是否缺失。
     * 供 initCtlData 在发起请求前返回 false，便于表格只关 loading，不回调业务 backFun。
     */
    const isRequiredQueryParamsMissing = function () {
        const queryParamsDs: any = deepClone(unref(dataConfig)?.queryUserParams);
        if (!queryParamsDs || !Array.isArray(queryParamsDs)) {
            return false;
        }
        const orderParams: any = {};
        let missing = false;
        queryParamsDs.forEach((itemDb) => {
            initQueryParamsObj(itemDb, pageModelsStore, orderParams, editorRecord);
            if (isRequiredQueryUserParamMissing(itemDb, orderParams)) {
                missing = true;
            }
        });
        return missing;
    }

    /** 监听参数变化------begin */
    // 回第 1 页时挡住 watch(current)，避免再打一枪只写 tableDs 的 initCtlData
    let skipCurrentWatchReload = false;
    let loadWhenChangeTimer = null;
    const tempIndex = unref(dataConfig)&&unref(dataConfig).queryUserParams?.findIndex((item) => item.loadWhenChange); // 判断是否有参数需要监听变化
    if (tempIndex >= 0) {
        // 序列化成字符串：flushGrid 会临时替换 queryUserParams 数组引用，值未变时 computed 保持稳定，避免误触发二次刷新
        const waitWatchParams = computed(() => {
            const res: any[] = [];
            unref(dataConfig)&&unref(dataConfig).queryUserParams?.forEach((item) => {
                appendLoadWhenChangeWatchValues(item, pageModelsStore, editorRecord, res);
            })
            return JSON.stringify(res);
        })
        watch(waitWatchParams, () => {
            // 延时500ms查询，防止：重置查询区域时，先清空参数，后设置默认值时，因频繁请求导致第二次请求中断。故延时500ms等待默认值设置完成后再进行查询
            // 连续变化只保留最后一次，避免多个 setTimeout 撞上 tableLoading 互锁把有效请求丢掉
            if (loadWhenChangeTimer) {
                clearTimeout(loadWhenChangeTimer);
            }
            loadWhenChangeTimer = setTimeout(() => {
                const reloadByParams = () => {
                    if (typeof onLoadWhenChange === 'function') {
                        onLoadWhenChange();
                        return;
                    }
                    initCtlData((res => {
                        tableDs.value = res?.res?.records;
                    }));
                };
                if (unref(current) !== 1) {
                    if (typeof onLoadWhenChange === 'function') {
                        skipCurrentWatchReload = true;
                        setPageCurrent(1);
                        reloadByParams();
                    } else {
                        setPageCurrent(1); // 修改页数 直接请求数据
                    }
                } else {
                    reloadByParams();
                }
            }, 500);
        })
        onBeforeUnmount(() => {
            if (loadWhenChangeTimer) {
                clearTimeout(loadWhenChangeTimer);
                loadWhenChangeTimer = null;
            }
        })
    }
    /** 监听参数变化------end */ 

    /**
     * 获取动态参数
     */
    const getDynamicParams = function() {
        if (unref(dataConfig) && unref(dataConfig).dynamicParamsFunc) {
            try {
                // 创建一个函数来执行动态参数代码
                const func = new Function('state', 'editorRecord', 'systemParamsMap', 'dataSourceStore', 'StorageUtils', `
                ${unref(dataConfig).dynamicParamsFunc}
                return getDynamicParams(state, editorRecord, systemParamsMap, dataSourceStore, StorageUtils);
                `);
                return func(unref(pageModelsStore.state), unref(editorRecord), unref(systemParamsMap), unref(dataSourceStore), StorageUtils) || {};
            } catch (e) {
                console.error('执行动态参数函数出错:', e);
                // 如果执行出错，返回空对象
                return {};
            }
        }
        return {};
    }

    const loadListDataByQueryUrl = async function (backFun?: any, queryParams?: any, method?: any, userDefUrl?: string) {
        if (unref(dataConfig) == null) {
            return;
        }
        if (queryParams == null) {
            queryParams = {};
        }

        // 添加动态参数
        const dynamicParams = getDynamicParams();
        queryParams = {...queryParams, ...dynamicParams};

        if (unref(dataConfig).queryUrl || unref(userDefUrl)) {
            let queryUrl = userDefUrl || unref(dataConfig).queryUrl;
            queryUrl = initQueryUrl(pageModelsStore, queryUrl);

            if (unref(queryParams)['paginationSize']) {
                delete unref(queryParams)['paginationSize']
            }

            const datas = await loadListByUrl({
                queryParams: {
                    ...queryParams,
                    size: unref(pageSizeRef),
                    sGridKey_:gridKey,
                    sPageCode_:GoingUtils.getPageCode(),
                    ...getSqlContentParams(gridKey, ctlAclInfos)
                },
                url: queryUrl,
                method,
                current: unref(current),
            },columns);
            afterLoadingFlag.value = true;
            closeCurLoading();
            if (datas == null) {
                tableLoading.value = false;
                return
            }
            const onceFullList = isOnceFullListPayload(datas);
            pageTotal.value = datas.total;
            if (unref(dataConfig).waitSelCols) {
                /**
                 * 设置映射字段信息
                 */
                datas.records.forEach((recordObj: any) => {
                    unref(dataConfig).waitSelCols.forEach(({value, mapField}) => {
                        recordObj[value] = recordObj[mapField];
                    })
                })
            }
            backFun && backFun({res: datas, onceFullList});
        } else {
            backFun && backFun([]);
        }
        tableLoading.value = false;
    }
    /**
     * 加载数据
     * 通过领域查询
     */
    const loadListDataByQuery = async function (backFun?: any, queryParams?: any) {
        const {filter, filterRelVal, paramsRel} = unref(dataConfig);
        const extendFilterParams = unref(dataConfig)['extendFilterParams'];
        const filterStr = JSON.stringify(getFilterJson(filter, filterRelVal, pageModelsStore, extendFilterParams));
        const orderFieldList = unref(dataConfig).orderFieldList;
        const orderParams = {};
        if (queryParams[0]) {
            delete queryParams[0];
        }
        //组装用户定义的查询参数
        const queryParamsDs: any = deepClone(unref(dataConfig).queryUserParams);
        let continueFlag: any = true;
        if (queryParamsDs && Array.isArray(queryParamsDs)) {
            queryParamsDs.forEach((itemDb) => {
                initQueryParamsObj(itemDb, pageModelsStore, orderParams, editorRecord);
                /**
                 * 如果用户申明了 参数必须有值 则无值的情况下 终止查询（开启备选时主参/备选 OR）
                 */
                if (isRequiredQueryUserParamMissing(itemDb, orderParams)) {
                    continueFlag = false;
                }
            })
        }
        /**
         * 如果存在必传参数 没有传 则直接终止
         */
        if (continueFlag === false) {
            continueFlag = true;
            tableLoading.value = false;
            closeCurLoading();
            console.log('必传参数不能为空');
            return
        }
        if (orderFieldList && orderFieldList.length > 0) {
            orderFieldList.forEach((itemDb) => {
                orderParams[`${itemDb.propId}_${itemDb.orderType}`] = itemDb.orderType;
            })
        }

        // 添加动态参数到orderParams中
        const dynamicParams = getDynamicParams();
        Object.assign(orderParams, dynamicParams);

        if (unref(dataConfig).domainCode || unref(dataConfig).userDefUrl) {
            let queryUrl = unref(dataConfig).useQueryUrl;
            queryUrl = initQueryUrl(pageModelsStore, queryUrl);

            if (unref(queryParams)['paginationSize']) {
                delete unref(queryParams)['paginationSize']
            }
            try{
                if(unref(queryParams)&&typeof (queryParams)==='object'){
                    Object.keys(unref(queryParams)).forEach((propName)=>{
                        if(unref(queryParams)[propName]==null||unref(queryParams)[propName]===''){
                            delete unref(queryParams)[propName];
                        }
                    })
                }
            }catch (e){}
            const urlParams = {
                userDefUrl: unref(dataConfig).userDefUrl,
                useQueryUrl: queryUrl,
                useQueryType: unref(dataConfig).useQueryType,
                pageCode: unref(dataConfig).domainCode,
                pageSize: queryParams.size||unref(pageSizeRef),
                formula: filterStr,
                current: queryParams.current != null ? queryParams.current : unref(current),
                queryParams: {...orderParams, ...queryParams, size: unref(pageSizeRef),
                    sGridKey_:gridKey,
                    sPageCode_:GoingUtils.getPageCode(),
                    ...getSqlContentParams(gridKey, ctlAclInfos)},
            };
            //如果是or 才需要传递，如果是and 则不需要啊
            if (unref(paramsRel) === 'or' || unref(tableObj).paramsRel) {
                urlParams['paramsRel'] = unref(tableObj).paramsRel || 'or';
            }
            //查询范围设置
            if (unref(dataConfig).lccQueryScopeType && unref(dataConfig).lccQueryScopeType !== 'currentAccount') {
                urlParams.queryParams['lccQueryScopeType'] = unref(dataConfig).lccQueryScopeType;
            }
            //设置表格的查询模式 是查询表头还是表头加子表
            if (unref(subGridListScopeFlag) && unref(dataConfig).hasSubGridList) {
                urlParams.queryParams['subGridListScope'] = unref(subGridListScopeVal);
            }
            try {
                let datas = await loadDomainList(urlParams,columns);
                tableLoading.value = false;
                closeCurLoading();
                afterLoadingFlag.value = true;

                if (datas == null) {
                    return
                }
                const onceFullList = isOnceFullListPayload(datas);
                pageTotal.value = datas.total || datas.length;
                //如果返回的数据不是放records里面
                if (datas.records == null && Array.isArray(datas)) {
                    const records = deepClone(datas);
                    datas = {records};
                }

                if (unref(dataConfig).successDeal) {
                    try {
                        const backRes = initSuccessDealDealStr(datas, unref(dataConfig).successDeal,pageModelsStore);
                        if (backRes != null && typeof (backRes) === 'object') {
                            //将返回回来的参数 给查询使用
                            datas = backRes;
                        }
                    } catch (e) {
                        console.log('successDeal', e)
                    }
                }

                if (unref(dataConfig).waitSelCols && Array.isArray(datas.records)) {
                    /**
                     * 设置映射字段信息
                     */
                    datas.records && datas.records.forEach((recordObj: any) => {
                        unref(dataConfig).waitSelCols.forEach(({value, mapField}) => {
                            recordObj[value] = recordObj[mapField];
                        })
                    })
                }
                if(unref(subGridListScopeFlag)&&unref(dataConfig).hasSubGridList){
                    initSubGridRecords(datas.records);
                }
                //如果页数大于1  但返回记录又没有查询到，则向上找一页
                if (Array.isArray(datas.records)) {
                    if (datas.records.length === 0 && urlParams.current > 1) {
                        loadListDataByQuery(backFun, {...queryParams, current: urlParams.current - 1});
                    }
                }
                backFun && backFun({res: datas, onceFullList});
            } catch {
                tableLoading.value = false;
                closeCurLoading();
            }
        } else {
            backFun && backFun([]);
            tableLoading.value = false;
        }
    }


    /**
     * 加载数据 通过vuex的数据源信息获取
     */
    const loadListDataByVuexDs = function (backFun?: any) {
        if (unref(dataConfig).selId) {
            if (unref(dataSourceStore.dataLoadFlags)[unref(dataConfig).selId]) {
                backFun && backFun({res: unref(dataSourceStore.dataListCache)[unref(dataConfig).selId]});
            } else {
                dataSourceStore.getDatasByQueryCode(unref(dataConfig).selId, pageModelsStore, ({res}) => {
                    afterLoadingFlag.value = true;
                    closeCurLoading();
                    backFun && backFun({res});
                });
            }

        } else {
            backFun && backFun([]);
        }
        tableLoading.value = false;
    }

    /**
     * 初始化全局变量
     */
    const initVuexDs = function (backFun) {
        unref(dataConfig).records = pageModelsStore.state[unref(dataConfig)['vuexName']];
        unref(dataConfig).systemChange = true;
        tableLoading.value = false;
        backFun && backFun({res: unref(dataConfig).records});
        afterLoadingFlag.value = true;
        closeCurLoading();
    }

    const initVuexWatch = function (backFun) {
        if (unref(watchVuexFlag) === false) {
            watchVuexFlag.value = true;
            watch(() => pageModelsStore.state[unref(dataConfig)['vuexName']], (newVal) => {
                initVuexDs(backFun);
                return;
            });
        }
    }

    const staticList = ref([]);
    /**
     * 前端查询操作
     * @param backFun
     * @param queryParams
     */
    const searchListByWebClient = function (backFun, queryParams) {
        if (unref(staticList).length === 0) {
            staticList.value = deepClone(unref(tableDs));
        }
        tableDs.value = [];
        const newRecordList = [];
        //查询参数长度大于0
        if (queryParams && Object.keys(queryParams) && Object.keys(queryParams).length > 0) {
            unref(staticList).forEach((recordDb) => {
                Object.keys(queryParams).forEach((propName) => {
                    if ((recordDb[propName] + '').indexOf((queryParams[propName] + '')) >= 0) {
                        newRecordList.push(recordDb);
                    }
                })
            })
            tableDs.value = newRecordList;
        } else {
            tableDs.value = deepClone(unref(staticList));
        }
    }

    const initCtlData = function (backFun?: any, queryParams?: any, userDefUrl?: string, dbSearch?: any, userHandlerQuery?: any,ctlLoadingFlag=false) {
        //如果没有开启组件loading 才需要开启 如果开启了才忽略
        if(unref(ctlLoadingFlag)){
            GoingUtils.showLoading();
            setTimeout(() => {
                closeCurLoading();
            }, 5000)
        }
        //如果静态标识为false 则不从数据库查询
        if (dbSearch === false) {
            searchListByWebClient(backFun, queryParams);
            return;
        }
        tableDs.value = [];
        if (unref(dataConfig) == null) {
            return;
        }
        if (queryParams == null) {
            queryParams = {};
        }

        // 添加动态参数
        const dynamicParams = getDynamicParams();
        queryParams = {...queryParams, ...dynamicParams};

        if (unref(dataConfig).queryParams) {
            if (queryParams == null) {
                queryParams = {};
            }

            if (unref(queryParams)['paginationSize']) {
                delete unref(queryParams)['paginationSize']
            }

            queryParams = {...queryParams, ...unref(dataConfig).queryParams, ...dynamicParams}
        }
        if (unref(dataConfig) == null) {
            return;
        }
        //数据来源类型
        if (unref(dataConfig).dataFormType === "static") {
            tableDs.value = unref(dataConfig).dataList || unref(dataConfig).list;
            if (unref(tableDs) && unref(tableDs).length === 0 && unref(dataConfig).list&&unref(dataConfig).list.length > 0) {
                tableDs.value = unref(dataConfig).list;
            }
            loadingFlag.value=false;
            return;
        }
        //如果加载中 则不用继续执行。return false 仅用于通知表格关闭 loading，不触发 backFun
        if (unref(tableLoading)) {
            console.error("==2次查询间隔太近，当前查询被忽略======queryParams", queryParams);
            tableLoading.value = false;
            closeCurLoading();
            return false;
        }
        if (dataConfig == null) {
            return;
        }
        
        tableLoading.value = true;
        //如果是定义了业务数据，根据业务数据进行查询
        if ((GoingNewUtils.parseBoolean(unref(dataConfig).userDef) || unref(dataConfig).domainCode || unref(dataConfig).useQueryUrl) && !userDefUrl) {
            if ((unref(dataConfig)['dateQueryType'] === 'vuexDef' || unref(dataConfig).dataSubFormType === 'vuexDef') && unref(dataConfig)['vuexName']) {
                initVuexWatch(backFun);
                nextTick(() => {
                    initVuexDs(backFun);
                })
                return;
            } else {
                //默认设置queryData为false 如果手动调用则userHandlerQuery为true
                if (unref(queryData) !== false || userHandlerQuery) {
                    if (unref(queryParams) && unref(dataConfig).pageSize) {
                        unref(queryParams)['size'] = unref(dataConfig).pageSize;
                    }

                    if (unref(queryParams)['paginationSize']) {
                        unref(queryParams)['size'] = unref(queryParams)['paginationSize']
                        delete unref(queryParams)['paginationSize']
                    }

                    // 必填参数未就绪时同步中止，避免表格 loading 一直等到兜底超时
                    if (isRequiredQueryParamsMissing()) {
                        tableLoading.value = false;
                        closeCurLoading();
                        console.log('必传参数不能为空');
                        return false;
                    }

                    loadListDataByQuery(backFun, queryParams);
                    return true;
                }
            }
        } else if ((unref(dataConfig).queryUrl || unref(userDefUrl)) && unref(queryData) !== false) {
            //根据指定查询url进行查询
            loadListDataByQueryUrl(backFun, queryParams, unref(dataConfig).method, unref(userDefUrl));
        } else if (unref(dataConfig).records) {
            //根据数据集合查询数据
            tableLoading.value = false;
            backFun && backFun({res: unref(dataConfig).records});
            afterLoadingFlag.value = true;
            closeCurLoading();
        } else {
            //如果是选择数据源的数据
            loadListDataByVuexDs(backFun);
        }
    }

    const setPageCurrent = function (currentVal: number) {
        current.value = currentVal;
    }

    watch(current, () => {
        // loadWhenChange 主动回第 1 页时跳过，避免与 onLoadWhenChange 重复请求
        if (skipCurrentWatchReload) {
            skipCurrentWatchReload = false;
            return;
        }
        initCtlData();
    })

//翻页操作
    const changePage = ({current, backFun, pageSizeVal}) => {
        pageSizeRef.value = pageSizeVal;
        setPageCurrent(current);
        backFun && backFun();
    }

    /**
     * 循环执行每条记录
     * @param backFun
     */
    const eachRowRecord = function (backFun) {
        if (Array.isArray(unref(tableDs)) && unref(tableDs).length >= 0) {
            unref(tableDs).forEach((itemRecord) => {
                backFun && backFun(itemRecord);
            })
        }
    }


    return {
        setSubGridQueryScope,
        afterLoadingFlag,
        eachRowRecord,
        changePage,
        setPageCurrent,
        tableLoading,
        pageTotal,
        loadingFlag,
        initCtlData,
        tableDs
    }
}
